import React from "react";
import {
  Box,
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

const AreaSelectionStep = ({
  areaCounts,
  existingAreaIds,
  selectedAreaIds,
  onToggleArea,
  onNext,
}) => {
  const eligibleAreas = areaCounts.filter(
    (area) => !existingAreaIds.has(area.id)
  );

  return (
    <>
      <Box sx={{ marginBottom: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Pick the areas where you want to add this product. Areas where it&apos;s
          already counted are hidden.
        </Typography>
      </Box>
      <Box
        sx={{
          maxHeight: 360,
          overflow: "auto",
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderRadius: 1,
          marginBottom: 4,
        }}
      >
        <List disablePadding>
          {eligibleAreas.map((area) => {
            const isSelected = selectedAreaIds.includes(area.id);
            return (
              <ListItem key={area.id} disablePadding>
                <ListItemButton
                  onClick={() => onToggleArea(area.id)}
                  sx={{
                    backgroundColor: (theme) =>
                      isSelected
                        ? theme.palette.primary[100]
                        : theme.palette.terrain[50],
                    borderBottom: "1px solid",
                    borderColor: (theme) => theme.palette.terrain[300],
                    "&:hover": {
                      backgroundColor: (theme) =>
                        isSelected
                          ? theme.palette.primary[100]
                          : theme.palette.terrain[100],
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Checkbox
                      edge="start"
                      checked={isSelected}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        {area.name}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

      <Box sx={{ marginTop: 4 }}>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={selectedAreaIds.length === 0}
          fullWidth
          sx={{ height: 48 }}
        >
          Confirm Areas
        </Button>
      </Box>
    </>
  );
};

export default AreaSelectionStep;
